module.exports = __webpack_public_path__ + "static/img/view6-1.9330ba3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lobby/components1030/img/1030/view6-1.png
// module id = 5Eh2
// module chunks = 1